class SecurityDepositSummary {
    /** @ngInject */
    constructor($window, $uibModal, Contract, SecurityDeposit, DataAccessVariables,
                ContactTelephone, ErrorCatcher) {
        this.$window = $window
        this.$uibModal = $uibModal
        this.Contract = Contract
        this.SecurityDeposit = SecurityDeposit
        this.DataAccessVariables = DataAccessVariables
        this.ContactTelephone = ContactTelephone
        this.ErrorCatcher = ErrorCatcher
    }

    $onInit() {
        this.depositAmount = 0
        this.isLoading = false
        this.error = null

        this.DataAccessVariables.get({ variables: 'DEPOSIT_AMOUNT' }).$promise.then((response) => {
            this.depositAmount = response.DEPOSIT_AMOUNT
        })
    }

    openFAQ() {
        this.$uibModal.open({
            animation: true,
            component: 'securityDepositFAQModal',
            resolve: {
                depositAmount: () => this.depositAmount,
            },
        })
    }

    cancelPayment() {
        this.$uibModal.open({
            animation: true,
            component: 'securityDepositCancelModal',
            resolve: {
                tokenId: () => this.tokenId,
                contractId: () => this.contractId,
            },
        })
    }

    postponePayment() {
        this.$uibModal.open({
            animation: true,
            component: 'securityDepositPostponeModal',
        })
    }

    goToPayment() {
        this.isLoading = true
        this.error = null
        let getRedirectPromise
        if (this.tokenId) {
            getRedirectPromise = this.SecurityDeposit.getRedirect({ tokenId: this.tokenId }).$promise
        } else {
            getRedirectPromise = this.Contract.getRedirectToSecurityDeposit({ id: this.contractId }).$promise
        }
        getRedirectPromise.then((redirectResult) => {
            this.$window.location = redirectResult.redirectUrl
        }).catch((error) => {
            this.ErrorCatcher.catchError(error)
            this.isLoading = false
            this.error = error
        })
    }
}

export default {
    template: require('./securityDepositSummary.jade')(),
    controller: SecurityDepositSummary,
    bindings: {
        depositInfo: '<',
        tokenId: '<',
        contractId: '<',
    },
}



// WEBPACK FOOTER //
// ./src/states/securityDepositSummary/securityDepositSummary.js